import { client } from "../../../Infrastructure/agent";

export const ebendoDailyProductionService = {
  downloadTemplate: () =>
    client.getFile(
      "/EbendoDailyProduction/DownloadEbendoDailyProductionTemplate"
    ),
  saveDailyProduction: (data, welldata, uploadedBy) =>
    client.post("/EbendoDailyProduction/SaveDailyProduction", {
      data,
      welldata,
      uploadedBy,
    }),

  loadProductionHistory: (query, view) =>
    client.post("/EbendoDailyProduction/LoadProductionHistory", {
      query,
      view,
    }),
  deleteProduction: (id, prodDate) =>
    client.post("/EbendoDailyProduction/DeleteProduction", {
      id,
      prodDate,
    }),

  getInitialWellParameters: () =>
    client.get("/EbendoDailyProduction/GetWellInitials"),

  getWellContributions: (pdate) =>
    client.post("/EbendoDailyProduction/GetWellContributions", { pdate }),
  getEbendoDailProductionById: (productionId, view) =>
    client.post("/EbendoDailyProduction/GetDailyProduction", {
      productionId,
      view,
    }),
  exportWellAllocation: (startDate, endDate, exportOnlyWellAllocationVolume) =>
    client.getFile(
      `/EbendoDailyProduction/ExportWellAlocations?startdate=${startDate}&enddate=${endDate}&exportOnlyWellAllocationVolume=${exportOnlyWellAllocationVolume}`
    ),
};

